import { IEntity } from 'app/projects/entity/src/lib/interfaces/entity.interface';
import { IMessageQuery } from '../interfaces/message.query.interface';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleType } from 'app/library/module/enums/moduleType.enum';

export class Message implements IEntity {
    static label_singular = 'message';
    static label_plural = 'messages';

    static props_to_search = ['name'];

    id: string;
    status: string;
    errorInfo: { extra: any; message: string } | null;
    resultInfo: { message: string } | null;
    title: string;
    imageUrl: string;
    entityId: string;
    entityType: string;
    asyncJob: { id: string };
    module?: {
        id: string;
        type: ModuleType;
        private: boolean;
        kind: ModuleKind;
    };

    constructor(query?: IMessageQuery) {
        if (query) {
            this.id = query.id.toString();
            this.status = query.status;
            this.errorInfo = query.error_info;
            this.resultInfo = query.result_info;
            this.title = query.title;
            this.imageUrl = query.image_url;
            this.entityId = query.entity_id ? query.entity_id.toString() : null;
            this.entityType = query.entity_type;
            this.asyncJob = query.async_job;

            if (query.module) {
                this.module = {
                    id: query.module.id.toString(),
                    type: query.module.type,
                    private: query.module.private,
                    kind: query.module.kind,
                };
            }
        }
    }
}
